import {observable, computed, action} from 'mobx';
import * as moment_ from 'moment';

import {
    OFFLINE_MODE_FLAG,
    UNDER_MAINTENANCE_FLAG,
    CONNECTION_ISSUE_FLAG,
    EMPTY_HEADER_FLAG,
    SHOP_CLOSED_WITH_ORDERS_FLAG
} from '../constants';

const moment = moment_;

export default class ConfigStore {

    @observable currentPage = 'shop';
    @observable designType;
    @observable display_id;
    @observable displayUnderMaintenance = false;

    @observable dateTime = new Date();
    @observable displayLoadingScreen = true;
    @observable firstTick = true;

    @observable useNames = false;

    @observable displayConnectionIssue = false;
    @observable checkResponseInterval = 45000;
    @observable receivedResponseWithinInterval = true;
    @observable isShopOpen = true;

    @observable promo = '';
    @observable qrCode = '';

    @observable isVertical = false;

    @observable hasError = false;
    @observable turnOffCdsAfterWorkingHoursFlag = false;

    @observable isTVEnabled = true;
    @observable shopClosedWithOrders = false;
    @observable nextShopStateChange;

    @observable isOfflineModeEnabled = false;
    @observable isHwUnderMaintenance = false;


    @action setHasError() {
        this.hasError = true;
    }

    //if the app crashes then we should speed up the rate that we check the s3 tag
    @action setS3EtagCheckRate(newCheckSpeed) {
        this.s3EtagCheckRate = newCheckSpeed;
    }

    @action setDisplayId(id){
        if(id) {
            this.display_id = id;
        }
    }

    @action setCurrentPage(newPage) {
        if(newPage) {
            this.currentPage = newPage;
        }
    }

    @action setDesignType(designType) {
        if(designType) {
            this.designType = designType;
        }
    }

    @action setETag(eTag){
        this.s3Etag = eTag;
    }

    //this is delivered from server as use Initials
    @action setUseNames(useInitials) {
        if(typeof useInitials === 'boolean') {
            this.useNames = useInitials;
        }
    }

    //this is use to update the screen there is a connection issue
    //should be run on an Interval, see. ReactInterval component in App
    @action checkConnection() {
        if(this.receivedResponseWithinInterval) {
            this.receivedResponseWithinInterval = false;
        } else {
            this.displayConnectionIssue = true;
        }
    }

    @action setPromo(promoUrl) {
        if(typeof promoUrl === 'string' &&
           promoUrl !== '') {
            this.promo = promoUrl;
        } else {
            this.promo = '';
        }
    }

    @action setQrCode(qrCode) {
        this.qrCode = qrCode
    }

    @action setShopClosedWithOrders(shouldIndicate) {
        this.shopClosedWithOrders = shouldIndicate;
    }

    @action setOfflineMode(isOfflineModeEnabled, isHwUnderMaintenance) {
        this.isOfflineModeEnabled = !!isOfflineModeEnabled;
        this.isHwUnderMaintenance = !!isHwUnderMaintenance;
    }

    @computed get displayOfflineMode() {
        return this.isOfflineModeEnabled && this.isHwUnderMaintenance;
    }

    @computed get usePromo(){
        return this.promo !== '';
    }

    //is there currently alert that should be appearing on the screen.
    @computed get isCurrentAlert() {
        return this.displayOfflineMode || this.displayConnectionIssue || this.displayUnderMaintenance || this.shopClosedWithOrders;
    }

    //return the correct display
    //return an empty object to keep all the css happy
    @computed get displayAlert() {
        if(this.displayOfflineMode) {
            return OFFLINE_MODE_FLAG;
        } else if(this.shopClosedWithOrders) {
            return SHOP_CLOSED_WITH_ORDERS_FLAG
        }
        else if(this.displayConnectionIssue) {
            return CONNECTION_ISSUE_FLAG;
        } else if(this.displayUnderMaintenance) {
            return UNDER_MAINTENANCE_FLAG;
        } else {
            return EMPTY_HEADER_FLAG;
        }
    }

    //return the correct header component to render when order panel
    //check if it is open, and check if there is a current alert.
    @computed get orderDisplayHeader() {
        if(!this.isShopOpen) {
            return;
        } else if(this.isCurrentAlert) {
            return this.displayAlert;
        }
        return;
    }

    @computed get isAlertShown() {
        return !!this.orderDisplayHeader
    }

    @action setIsShopOpen(isOpen) {
        if(typeof isOpen === 'boolean') {
            this.isShopOpen = isOpen;
        }
    }

    @action updateReceivedResponse(){
        this.displayConnectionIssue = false;
        this.receivedResponseWithinInterval = true;
    }

    @action toggleFirstClick(){
        this.firstTick = false;
    }
    @action setUnderMaintence(is_hw_um) {
        if(typeof is_hw_um === 'boolean') {
            this.displayUnderMaintenance = is_hw_um;
        }
    }

    @action setIsTVEnabled(isEnabled) {
        if(typeof isEnabled === 'boolean') {
            this.isTVEnabled = isEnabled;
        } else {
            this.isTVEnabled = true
        }
    }

    @computed get currentDateTime() {
        //use the DateFNS library to render the time appropriately
        var time = moment(this.dateTime, 'YYYY-MM-DDTh:mm:ss.SS');
        let dateString = time.format('ddd, MMM Do, h:mma');
        return dateString;
    }

    @computed get formattedNextShopStateChange() {
        return moment(this.nextShopStateChange).format('ddd h:mm a')
    }

    @action turnOffLoadingScreen() {
        this.displayLoadingScreen = false;
    }

    @action updateDateTime(dateString) {
        //ex. dateString: 2018-01-17T19:54:23.334466
        this.dateTime = dateString;
    }

    @action setNextShopStateChange(time) {
        this.nextShopStateChange = time
    }

    @action calcIsVertical(){
        this.isVertical = window.innerHeight > window.innerWidth
    }

    @action setTurnOffCdsAfterWorkingHoursFlag(shouldTurnOff) {
        this.turnOffCdsAfterWorkingHoursFlag = Boolean(shouldTurnOff);
    }
}



// WEBPACK FOOTER //
// ./src/stores/ConfigStore.js